import { useCallback } from "react";
import { useCancelModal } from "../../customhooks";
import { SessionExpiredModalStyled } from "./sessionexpiredmodal.styles";

import { getLogoutUrl } from "../../utils";
import { warningYellowInCircleIcon } from "../../svgs";
import Button from "../button";
import { LOCAL_STORAGE_CONSTANTS } from "../../constants";

function SessionExpiredModal(): JSX.Element {
  const onCancelModal = useCancelModal();

  const onOk = useCallback(() => {
    localStorage.clear();
    localStorage.setItem(
      LOCAL_STORAGE_CONSTANTS?.last_logged_in_url,
      window?.location?.href
    );
    onCancelModal();
    window.location.href = getLogoutUrl();
  }, []);

  return (
    <SessionExpiredModalStyled>
      {warningYellowInCircleIcon()}
      <div className="title">Your session has expired.</div>
      <div className="desc">
        You’ve been signed out. Please sign in again to continue using the app.
      </div>
      <Button className="button" width="82px" onClick={onOk}>
        Sign In
      </Button>
    </SessionExpiredModalStyled>
  );
}

export default SessionExpiredModal;
